import { api } from "./api";

/**
 * Store Employee Master — /store-employees/*
 *
 * The shared `api` instance's baseURL already ends in /api, so paths start at
 * /store-employees.
 *
 * Employees form a reporting tree: every record carries `reporting_to`
 * (another employee's sem_id) and the API returns `reporting_to_details`
 * alongside it, so the manager's name can be shown without a second lookup.
 *
 * The API rejects, with a message worth surfacing verbatim:
 *   409  employee_code already exists
 *   409  employee_contact_number already exists
 *   400  Employee cannot report to themselves
 */

function buildParams(obj) {
  const out = {};
  Object.keys(obj || {}).forEach((key) => {
    const value = obj[key];
    if (value === null || value === undefined || value === "") return;
    out[key] = value;
  });
  return out;
}

/** GET /store-employees/list — paged; `search` matches code and name. */
export const storeEmployeeListApi = ({ pageNumber = 1, pageSize = 20, search } = {}) =>
  api.get("/store-employees/list", {
    params: buildParams({ pageNumber, pageSize, search }),
  });

/** GET /store-employees/detail?sem_id= */
export const storeEmployeeDetailApi = (sem_id) =>
  api.get(`/store-employees/detail?sem_id=${sem_id}`);

/** POST /store-employees/create */
export const storeEmployeeCreateApi = (params) =>
  api.post("/store-employees/create", JSON.stringify(params));

/** POST /store-employees/update — `sem_id` identifies the record. */
export const storeEmployeeUpdateApi = (params) =>
  api.post("/store-employees/update", JSON.stringify(params));

/** POST /store-employees/delete?sem_id= — soft delete (is_delete = true). */
export const storeEmployeeDeleteApi = (sem_id) =>
  api.post(`/store-employees/delete?sem_id=${sem_id}`);

/**
 * GET /store-employees/dropdown — trimmed list for pickers.
 * Rows are { sem_id, employee_code, employee_name }. Used for the Reporting To
 * picker here and for Relationship Manager on Store Details.
 */
export const storeEmployeeDropdownApi = ({ pageNumber = 1, pageSize = 200, search } = {}) =>
  api.get("/store-employees/dropdown", {
    params: buildParams({ pageNumber, pageSize, search }),
  });
